module.exports = __webpack_public_path__ + "img/springgds.1b43ce24.png";